import { resetStateForNewServiceLocationActionCreator } from 'src/state/address/action-creators/reset-state-for-new-service-location-action-creator';
import { resetServiceLocation } from 'src/state/address/address-slice';
import { setReachedStep } from 'src/state/order/order-slice';
import { OrderStep } from 'src/state/order/types';
import { AppDispatch } from 'src/state/types';

export const resetStateForNewAccountActionCreator = () => (dispatch: AppDispatch) => {
  dispatch(resetServiceLocation());
  dispatch(resetStateForNewServiceLocationActionCreator());
  dispatch(setReachedStep(OrderStep.CHOOSE_ACCOUNT));
};
